export default __webpack_public_path__ + "static/media/h5-bg8.daf64fdb.png";